<template>
  <div class="cruise-search-bar-container" :class="{ dn: !isContainerShow }">
    <div class="search-wrapper" data-type="hp">
      <div
        class="search-port search-comm"
        :class="{ 'search-has-item': selectedDepartureCount > 0 }"
        @click="showForm('departure')"
      >
        <span class="search-item-title"
          >选择出发港<span class="badge" v-if="selectedDepartureCount > 0">{{
            selectedDepartureCount
          }}</span></span
        >
        <span class="startPort search-item-content">{{
          selectedDepartures
        }}</span>
        <img
          src="https://resource.rcclchina.com.cn/homePage/mobile/port.png"
          alt=""
        />
      </div>
      <div
        class="search-time search-comm"
        :class="{ 'search-has-item': selectedSailDateCount > 0 }"
        @click="showForm('sailDate')"
      >
        <span class="search-item-title"
          >选择出发时间<span class="badge" v-if="selectedSailDateCount > 0">{{
            selectedSailDateCount
          }}</span></span
        >
        <span class="dateValue search-item-content">{{
          selectedSailDates
        }}</span>
        <img
          src="https://resource.rcclchina.com.cn/homePage/mobile/dataTime.png"
          alt=""
        />
      </div>
      <div
        class="search-dest search-comm"
        :class="{ 'search-has-item': selectDestinationCount > 0 }"
        @click="showForm('destination')"
      >
        <span class="search-item-title"
          >选择目的地<span class="badge" v-if="selectDestinationCount > 0">{{
            selectDestinationCount
          }}</span></span
        >
        <span class="destinationPort search-item-content">{{
          selectDestinations
        }}</span>
        <img
          src="https://resource.rcclchina.com.cn/homePage/mobile/ship.png"
          alt=""
        />
      </div>
      <a class="search-btn" @click="onSearchBtnClick">航线搜索</a>
    </div>
    <DepartureForm
      :cruiseType="cruiseType"
      :departures="getDepartures()"
      :departureGroups="departureGroups"
      :isShow="componentShow == 'departure'"
      :closeForm="closeForm"
    />

    <SailDateForm
      :cruiseType="cruiseType"
      :isShow="componentShow == 'sailDate'"
      :closeForm="closeForm"
    />
    <DestinationForm
      :cruiseType="cruiseType"
      :destinations="destinations"
      :isShow="componentShow == 'destination'"
      :closeForm="closeForm"
    />
  </div>
</template>
<script>
const DepartureForm = () => import("@/components/Home/SearchBar/DepartureForm");
const SailDateForm = () => import("@/components/Home/SearchBar/SailDateForm");
const DestinationForm = () => import("@/components/Home/SearchBar/DestinationForm");
import { gioTracking } from "@/utilities/tools";
export default {
  name: "SearchBarContainer",
  components: {
    DepartureForm,
    SailDateForm,
    DestinationForm,
  },
  props: {
    cruiseType: {
      type: String,
      default: function () {
        return "hp";
      },
    },
    cruiseFilters: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isContainerShow: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      componentShow: "",
    };
  },
  mounted: function () {},
  methods: {
    showForm(component) {
      if (this.componentShow == component) {
        this.componentShow = "";
      } else {
        this.componentShow = component;
        this.$store.dispatch("HIDE_HEADER_BAR", {
          isHideHeader: true,
          isHideFooter: true,
        });
      }
    },
    closeForm() {
      this.componentShow = "";
      this.$store.dispatch("HIDE_HEADER_BAR", {
        isHideHeader: false,
        isHideFooter: false,
      });
    },
    getDepartures() {
      const platform = this.cruiseType == "hp" ? "HP" : "TUI";
      return this.cruiseFilters.filter(function (filter) {
        return (
          filter.platform == platform &&
          filter.category == "DEPARTURE" &&
          filter.active
        );
      });
    },
    onSearchBtnClick() {
			gioTracking('track','evt_ButtonClicked', {'btnType':'mainSch'});
      const filters = this.$store.state.cruise.filterRequest[this.cruiseType];
      let url = "/Rccl.Cruise/CruiseSearch/Search";
      if (this.cruiseType == "row") {
        url = process.env.VUE_APP_TUI_URL + "/Cruise/Search";
      }
      let query = [];
      if (filters.departures.length > 0) {
        query.push(
          "departureCodes=" +
            filters.departures.map((item) => item.code).join(",")
        );
      }
      if (filters.sailDates.length > 0) {
        query.push(
          "sailDates=" + filters.sailDates.map((item) => item.code).join(",")
        );
      }
      if (filters.destinations.length > 0) {
        query.push(
          "destinationCodes=" +
            filters.destinations.map((item) => item.code).join(",")
        );
      }
      if (query.length > 0) {
        url += "?" + query.join("&");
      }
      if (this.cruiseType == "row") {
        window.location = url;
      } else {
        this.$router.push(url);
      }
    },
  },
  computed: {
    departureGroups() {
      let groups = [];
      this.getDepartures().forEach((departure) => {
        if (!groups.includes(departure.cruiseFilterGroupName))
          groups.push(departure.cruiseFilterGroupName);
      });
      return groups;
    },
    destinations() {
      const platform = this.cruiseType == "hp" ? "HP" : "TUI";
      return this.cruiseFilters.filter(function (filter) {
        return (
          filter.platform == platform &&
          filter.category == "DESTINATION" &&
          filter.active
        );
      });
    },
    selectedDepartureCount() {
      const items = this.$store.state.cruise.filterRequest[this.cruiseType]
        .departures;
      return items.length;
    },
    selectedDepartures() {
      const departures = this.$store.state.cruise.filterRequest[this.cruiseType]
        .departures;
      let departureNames = [];
      departures.forEach((item) => {
        departureNames.push(item.name);
      });
      if (departureNames.length == 0) {
        return "";
      }
      return departureNames.join("、");
    },
    selectedSailDateCount() {
      const items = this.$store.state.cruise.filterRequest[this.cruiseType]
        .sailDates;
      return items.length;
    },
    selectedSailDates() {
      const sailDates = this.$store.state.cruise.filterRequest[this.cruiseType]
        .sailDates;
      let sailDateList = [];
      sailDates.forEach((item) => {
        sailDateList.push(item.name.replace(/-/g, "/"));
      });
      if (sailDateList.length == 0) {
        return "";
      }
      return sailDateList.join("、");
    },
    selectDestinationCount() {
      const items = this.$store.state.cruise.filterRequest[this.cruiseType]
        .destinations;
      return items.length;
    },
    selectDestinations() {
      const destinations = this.$store.state.cruise.filterRequest[
        this.cruiseType
      ].destinations;
      let destinationNames = [];
      destinations.forEach((item) => {
        destinationNames.push(item.name);
      });
      if (destinationNames.length == 0) {
        return "";
      }
      return destinationNames.join("、");
    },
  },
};
</script>
